import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import MeasurementsBody from './body.tsx';
import MeasurementsHeader from './header.tsx';

const Measurements = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLoggedIn)
            navigate("/login");
    }, [isLoggedIn, navigate]);

    if (!isLoggedIn)
        return null;

    return (
        <>
            <MeasurementsHeader />
            <MeasurementsBody />
        </>
    );
};

export default Measurements;
